import { getAPIHeaders } from "../app/utils";
import { serverApi } from "../services";

export const getRisks = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("risks", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postRisk = async (payload) => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("risks", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putRisk = async ({ id, payload }) => {
  try {
    const reqOpts = getAPIHeaders({ RISK_ID: id });
    const response = await serverApi.put(`risks`, payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
